<template lang="pug">
    .battle-box(:class="{'battle-box_blue': color === 2, 'battle-box_orange': color === 3}", :style="styleText")
        .battle-box__content
            .battle-name {{ battle.name }}
            div.buttons
                button.button.battle-description-button(
                    v-if="user.type === 'student'"
                    type="button",
                    :disabled="user.type !== 'student'",
                    @click="$emit('showDescription', battle)"
                )
                    | {{ $i18n.t('battle.battle_checkDescription') }}
                cs-button.button.battle-description-button(
                    v-if="battle.creatorId === user.id && !user.isSuperadmin"
                    type="button",
                    color="blue"
                    @click="$router.push({ name: 'battle-training:edit', params: { battleId: battle.id } })"
                )
                    | {{ $i18n.t('battle.battle_edit_editBattle') }}
                cs-button.button.battle-description-button(
                    v-if="battle.creatorId === user.id && !user.isSuperadmin"
                    type="button",
                    color="blue"
                    @click="deleteBattle"
                )
                    | {{ $i18n.t('battle.battle_edit_deleteBattle') }}
                cs-button.button.battle-start-button(
                    v-if="user.type === 'student'"
                    type="button",
                    :disabled="inappropriateDeviceForNavigatorGame",
                    @click="$emit('showListOpponents', battle.id)"
                )
                    | {{ $i18n.t('battle.battle_start') }}
</template>

<script>
    import { mapState } from 'vuex';
    import BattleApi from '../../../api/battle';

    export default {
        props: {
            battle: Object,
        },
        mounted() {
            this.color = Math.floor(Math.random() * 3) + 1;
            if (this.battle && !this.battle.logo.includes('no-photo.svg')) {
                this.styleText = `background:url(${this.battle.logo})`;
            }
        },
        data() {
            return {
                color: 1,
                styleText: '',
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            inappropriateDeviceForNavigatorGame() {
                let currentWidth = window.innerWidth;
                return (
                    currentWidth < 768 &&
                    !!this.battle.levels.find(level => {
                        return level.stages.find(stage => {
                            return stage.games.find(game => {
                                return game.slug === 'Navigator' && game.parameters.default.difficult > 7;
                            });
                        });
                    })
                );
            },
        },
        methods: {
            deleteBattle() {
                BattleApi.delete(this.battle.id)
                    .then(() => {
                        this.$toasted.success(this.$root.$t('battle.battle_deleted'));
                        this.$emit('delete', this.battle.id);
                    })
                    .catch(err => {
                        if (err.data && err.data.status_code === 403) {
                            this.$toasted.error(this.$root.$t('errors.olympiad_no_access'));
                        } else {
                            this.$toasted.error(this.$root.$t('errors.deleting_battle'));
                        }
                        this.$router.push({ name: 'dashboard' });
                    });
            },
        },
    };
</script>

<style scoped lang="scss">
    .battle-box {
        box-sizing: border-box;
        float: left;
        width: 48%;
        height: 100%;
        border-radius: 20px;
        padding: 30px;
        @include media($xl) {
            width: 49%;
            padding: 50px;
        }
        margin-bottom: 30px;
        //background: url("../../../assets/images/battles/battle-background.png") #6BBD6C;

        //todo: remove after the New Year!
        background: url('../../../assets/images/battles/battle-background-new-year.png') #6bbd6c;
        font-family: 'Rubik';
        text-align: center;
        &:nth-child(2n + 1) {
            margin-right: 3%;
            @include media($xl) {
                margin-right: 2%;
            }
        }
        @media screen and (max-width: 359px) {
            padding: 15px;
        }
        @media screen and (max-width: 768px) {
            width: 100%;
            float: none;
        }
        &_right-offset {
            margin-right: 30px;
        }
    }
    .battle-box_blue {
        background-color: #2187ff;
    }
    .battle-box_orange {
        background-color: #ffad1f;
    }
    .battle-box__content {
        background: #ffffff;
        border-radius: 20px;
        padding: 45px 25px;
        @media screen and (max-width: 359px) {
            padding: 45px 10px;
        }
    }
    .battle-name {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        color: #333333;
    }
    .buttons {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    .button {
        height: auto;
        border-radius: 40px;
        padding: 15px 30px;
        margin-top: 15px;
        width: 238px;
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        border: 0;
        white-space: nowrap;
        @media screen and (max-width: 460px) {
            padding: 15px 5px;
            width: 100%;
        }
        @media screen and (min-device-width: 769px) and (max-device-width: 824px) {
            padding: 15px 5px;
            width: 190px;
        }
        @media screen and (min-device-width: 825px) and (max-device-width: 900px) {
            padding: 15px 5px;
            width: 200px;
        }
    }
    .battle-description-button {
        background-color: white;
        border: 1px solid #2187ff;
        box-sizing: border-box;
        color: #2187ff;
        &:hover {
            cursor: pointer;
            background: #2187ff;
            color: #ffffff;
        }
        /*        @media screen and (max-width: 440px) {
            font-size: .8rem;
        }
        @media screen and (max-width: 420px) {
            font-size: .65rem;
        }
        @media screen and (max-width: 370px) and (min-width: 360px) {
            font-size: .6rem;
        }
        @media screen and (max-width: 360px) {
            font-size: .9rem;
        }*/
    }
    .battle-start-button {
        background: #2187ff;
        color: #ffffff;
        &:hover {
            cursor: pointer;
            background: #0070f4;
        }
    }
</style>
